/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, window) {
	'use strict';

	Module.EloquaLP = Module.extend({

		on: function (callback) {
			this.loadData();
			callback();
		},

		// case subscription center, email provide a link with param elq=<eloqua-id>
		getUrlParam: function(name) {
			var queryParams = new URLSearchParams(window.location.search);
			var results = queryParams.get(name);
			return (results !== null) ? results || 0 : false;
		},

		// handles for unique fields
		handleWebinarUnique: function(form) {
			var testField = $('[name="WebinarUnique"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var webinarUnique = document.getElementsByName("WebinarUnique")[0];
				var webinarId = document.getElementsByName("WebinarId")[0];
				var email = document.getElementsByName("C_EmailAddress")[0];
				webinarUnique.value = webinarId.value + "(" + email.value + ")";
				// to set the Lead topic
				var unique = document.getElementsByName("Unique")[0];
				var topic = document.getElementsByName("Topic")[0];
				unique.value = topic.value + "_" + email.value;
			});
		},

		handleEventUnique: function(form) {
			var testField = $('[name="EventUnique"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var eventUnique = document.getElementsByName("EventUnique")[0];
				var eventname = document.getElementsByName("Eventname")[0];
				var email = document.getElementsByName("C_EmailAddress")[0];
				eventUnique.value = eventname.value + "_" + email.value;
				// step to make the Lead unique value
				var unique = document.getElementsByName("Unique")[0];
				var topic = document.getElementsByName("Topic")[0];
				unique.value = topic.value + "_" + email.value;
			});
		},

		handleOrderUnique: function(form) {
			var testField = $('[name="Date"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)");
				unique.value = topic.value + "_" + email.value;
				var date = document.querySelector("[name=Date]:not(meta)");
				date.value = (new Date()).toLocaleString("en-GB");
			});
		},

		handleOfferUnique: function(form) {
			var productHolder = undefined;
			var testField = $('[name="ProductOwner"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)")
				unique.value = topic.value + "_" + email.value;
				var product = document.querySelector("[name=Product]:not(#Product)");
				var productOwner = document.querySelector('[name=ProductOwner]:not(#ProductOwner)');
				var eDate = (new Date()).toLocaleString("en-GB");

				productHolder = productHolder || product.value;
				product.value = eDate + " -ProductName: " + productHolder + " -ProductOwner: " + productOwner.value;
			});
		},

		handleExpertUnique: function(form) {
			var productHolder = undefined;
			var testField = $('[name="ExpertEmail"]')[0];
			if(testField === undefined) {
				return;
			}

			form.addEventListener("submit", function (event) {
				var email = document.querySelector("[name=C_EmailAddress]:not(meta)");
				var unique = document.querySelector("[name=Unique]:not(meta)");
				var topic = document.querySelector("[name=Topic]:not(#Topic)");
				unique.value = topic.value + "_" + email.value;

				var eDate = (new Date()).toLocaleString("en-GB");
				var product = document.querySelector("[name=Product]:not(#Product)");

				productHolder = productHolder || product.value;
				product.value = eDate + " -Product: " + productHolder;

			});
		},

		initSubmitListener: function(form) {
			var fieldValidities = new Map();
			function initLiveValidationListeners() {
				if (!('LiveValidationForm' in window)) {
					setTimeout(initLiveValidationListeners, 100);
					return;
				}
				var lv = LiveValidationForm.getInstance(form);
				for (var i = 0; i < lv.fields.length; i++) {
					const lvField = lv.fields[i];
					fieldValidities.set(lvField, false);
					// eslint-disable-next-line @typescript-eslint/unbound-method
					var oldOnValid = lvField.onValid;
					lvField.onValid = function () {
						fieldValidities.set(lvField, true);
						return oldOnValid.apply(this, arguments);
					};
					// eslint-disable-next-line @typescript-eslint/unbound-method
					var oldOnInvalid = lvField.onInvalid;
					lvField.onInvalid = function () {
						fieldValidities.set(lvField, false);
						return oldOnInvalid.apply(this, arguments);
					};
				}
			}
			initLiveValidationListeners();

			var elqAdobeID = form.querySelector('input[name=Eloqua-Adobe-ID]');
			form.addEventListener("submit", function () {
				LiveValidation.massValidate(LiveValidationForm.getInstance(form).fields);

				if (Array.from(fieldValidities.values()).every(Boolean)) {
					doTracking(elqAdobeID);
					replaceWithLoadingButton(form);
				}
			});

		},


		handleUnique: function(form) {
			this.handleWebinarUnique(form);
			this.handleEventUnique(form);
			this.handleOrderUnique(form);
			this.handleOfferUnique(form);
			this.handleExpertUnique(form);
		},

		getScript: function (scriptsWithSource, scripts, i) {
			i = i || 0;
			var mod = this;
			$.getScript($(scriptsWithSource[i]).attr("src"), function () {
				i++;
				if (scriptsWithSource.length === i) {
					scripts.forEach(function (script) {
						$("head").append(script);
					});
				}
				;
				scriptsWithSource.length > i && mod.getScript(scriptsWithSource, scripts, i);
			});
		},

		prepareForm: function(data) {

			// Remove the html tag tracking pixel
			data = data.slice(0, data.lastIndexOf('</html>') + 7);
			var responseDOM = $.parseHTML(data, true);
			// The main div in the body of the landing page
			var mainDivElement;
			// array that will contain script tags with a source
			var scriptsWithSource = [];
			// array that will contain script tags without a source
			var scripts = [];

			// Iterate over node list. Meta and script tags should be appended in the head, while the main div of the body should be saved for later
			responseDOM.forEach(function (node) {
				if (node.tagName == undefined) return;
				if (node.tagName.toLowerCase() == "meta" || node.tagName.toLowerCase() == "script") $("head").append(node);
				if (node.tagName.toLowerCase() == "div") mainDivElement = node;
			})

			// Iterate over main div elements to find script inserted in the body, append them in the correct list and remove them from the div
			$(mainDivElement).find("*").each(function (index) {
				if (this.tagName == undefined) return;
				if (this.tagName.toLowerCase() == "script") {
					if ($(this).attr("src") != null) {
						scriptsWithSource.push(this);
					} else {
						scripts.push(this);
					}
					this.remove();
				}
			});

			// Replace the content div with the main div (now stripped of the script tags)
			this.$ctx.append(mainDivElement);
			//$("#content").replaceWith(mainDivElement);

			// Scripts with a source should be appended to head and then loaded
			this.getScript(scriptsWithSource, scripts);

			// Insert meta values in html body fields
			$('.hiddenFieldParsys :input').each(function () {
				$('.modEloquaLP form :input[name=' + this.name + ']').val($(this).attr("value"));
			});

			$('.field-control-wrapper .list-order.one-column').parent().css('display', 'block');

			const twoCol = $('.layout-col.col-sm-6');
			twoCol.css('flex', '0 0 100%').css('max-width', '100%');
			twoCol.parent().css('flex', '0 0 50%').css('max-width', '50%');

			// Insert success/error url values in html body fields
			$('form :input[name=' + this.$ctx.data('lp-error-key') + ']').val(this.$ctx.data('lp-error-url'));
			$('form :input[name=' + this.$ctx.data('lp-success-key') + ']').val(this.$ctx.data('lp-success-url'));

			var form = document.getElementsByClassName("elq-form")[0];
			if(form === null) {
				return;
			}
			this.handleUnique(form);
			this.initSubmitListener(form);
			// Modify the default onSubmit, to handle additional logic of the form
			/**
			 * NOTE: here I suppose there is only a form tag in the html page.
			 *
			 * **/
			$('form').removeAttr('onsubmit')
				.submit(function (event) {
					// On submit, populate the hidden field Unique
					$("form :input[name=Unique]").val($("form :input[name=Topic]").val() + "_" + $("form :input[name=C_EmailAddress]").val());
				});


		},

		loadData: function () {

			var mod = this;
			var $ctx = this.$ctx;
			var subdirectory = 'b2bmarketing-nocookie';
			if (window.SCS && window.SCS.datalayer && window.SCS.datalayer.getConsent('visitorRecognition')) {
				subdirectory = 'b2bmarketing';
			}
			var ajaxUrl = '/portal-services/' + subdirectory +'/LP=' + encodeURIComponent($ctx.data('lp-id'));
			var elq = encodeURIComponent(this.getUrlParam("elq"));

			jQuery.ajax({
				type: 'GET',
				async: true,
				dataType: 'html',
				data: {
					elq_ck: 0,
					elq: elq
				},
				url: ajaxUrl
			})
				.done(function(data) { mod.prepareForm.call(mod, data);})
				.error(function (xhr, state, err) {
					// xhr === req
					console.log('error', this, xhr, state, err);
				});

		},

	});

	function doTracking(elqAdobeID) {
		if (!elqAdobeID) {
			return;
		}
		var uuid = crypto.randomUUID();
		elqAdobeID.value = uuid;

		if (!window.SCS || !window.SCS.datalayer) {
			return;
		}

		const data = window.SCS.datalayer.cloneMandatoryData();
		data.event = {
			action: "button",
			label: "aaeloquaid",
			location: "leadforms",
			category: "eloqua"
		};
		data.apps = {
			analytics: {
				aaeloquaid: uuid
			}
		};
		window.SCS.datalayer.track(data);
	}


	function replaceWithLoadingButton(form) {
		const button = form.querySelector('input[type="submit"]');
		button.setAttribute('style', 'display: none;');
		const sdxButton = document.createElement('sdx-button');
		sdxButton.loading = true;
		button.parentElement.prepend(sdxButton);
	}

}(window.Tc.Module, window.Tc.$, window));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.EloquaLP.js
// module id = 139
// module chunks = 0